/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
var e,t;!function(e){e[e.RasterImage=0]="RasterImage",e[e.Features=1]="Features"}(e||(e={})),function(e){e[e.WithRasterImage=0]="WithRasterImage",e[e.WithoutRasterImage=1]="WithoutRasterImage"}(t||(t={}));export{e as DrapeSourceType,t as DrapeTargetType};
